module.exports = __webpack_public_path__ + "img/EMT-OVCA_10X_WTA.a84a0a34.png";